var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLegalinfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2365 5104 c-376 -39 -663 -120 -967 -275 -549 -280 -987 -765 -1213 -1341 -121 -311 -170 -576 -170 -928 0 -228 8 -317 46 -505 151 -754 651 -1414 1337 -1764 266 -135 533 -218 847 -263 117 -16 513 -16 630 0 759 108 1390 498 1804 1117 221 329 353 683 413 1100 17 118 17 512 0 630 -60 417 -192 771 -413 1100 -406 606 -1025 997 -1759 1110 -101 15 -467 28 -555 19z m406 -264 c547 -54 1054 -298 1429 -686 866 -897 866 -2291 0 -3188 -811 -840 -2120 -929 -3050 -208 -855 664 -1124 1860 -635 2827 426 843 1330 1346 2256 1255z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2440 3720 l0 -180 170 0 170 0 0 180 0 180 -170 0 -170 0 0 -180z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2440 2375 l0 -835 170 0 170 0 0 835 0 835 -170 0 -170 0 0 -835z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalinfo);
export default __webpack_public_path__ + "static/media/legal info.a6181a7b2a1b0db949163acaaa49cc20.svg";
export { ForwardRef as ReactComponent };